// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as AuthContextV1$PorterinFeature from "./AuthContextV1.mjs";

var provider = AuthContextV1$PorterinFeature.context.Provider;

function AuthProviderV1$Provider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider, {
              value: value,
              children: children
            });
}

var Provider = {
  provider: provider,
  make: AuthProviderV1$Provider
};

export {
  Provider ,
}
/* provider Not a pure module */
